import { STORY_SEQUENCE_TYPES, SEQUENCE_STATUS } from '../../constants/constants';
//TODO: GET RID OF SEQUENCE STATUS WHEN REWORKING THE DATA STRUCTURE

export function getMockedSkillsDiagnosticData(studentId) {
  return mockData[studentId];
}

const mockData = {
  // You can add your mocked data here if you need it
};
